export const statut_projetConstants = {
    GETALL_STATUT_PROJET_REQUEST: "GETALL_STATUT_PROJET_REQUEST",
    GETALL_STATUT_PROJET_SUCCESS: "GETALL_STATUT_PROJET_SUCCESS",
    GETALL_STATUT_PROJET_FAILURE: "GETALL_STATUT_PROJET_FAILURE",
};
